<template>
  <div class="claim">
    <YorkbbsImage
      class="claim-icon"
      width="80px"
      height="80px"
      :src="require('@/assets/images/info/claim.png')"
    ></YorkbbsImage>
    <div class="claim-title">这是你的店么？</div>
    <div class="claim-subtitle">认领店铺可更新信息、回评论</div>
    <div>
      <el-button class="claim-button" size="medium" @click="showClaimDialog">立即认领</el-button>
    </div>

    <!-- 认领对话框 -->
    <YorkbbsClaimDialog :visible.sync="claimVisible" :id="$route.params.id"></YorkbbsClaimDialog>
  </div>
</template>

<script>
import YorkbbsClaimDialog from '../components/dialog-claim.vue';
export default {
  name: 'ShopClaim',
  components: { YorkbbsClaimDialog },
  data() {
    return {
      // 认领显示状态
      claimVisible: false,
    };
  },
  computed: {
    isLogin() {
      return this.$store.getters.isLogin;
    },
  },
  methods: {
    /**
     * 显示认领对话框
     */
    showClaimDialog() {
      if (!this.isLogin) return this.$store.commit('setLoginDialogVisible', true);
      this.claimVisible = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.claim {
  background: #ffffff;
  border: 1px solid #ededed;
  border-radius: 4px;
  padding: 30px 55px;
  margin-bottom: 20px;
}

.claim-icon {
  margin-bottom: 20px;
  margin: auto;
}

.claim-title {
  font-size: 18px;
  font-weight: 500;
  line-height: 25px;
  color: var(--text-color-3);
  margin-bottom: 5px;
  text-align: center;
}
.claim-subtitle {
  font-size: 12px;
  color: var(--text-color-9);
  line-height: 22px;
  margin-bottom: 30px;
  text-align: center;
}
.claim-button {
  width: 100%;
}
</style>
